export const AUTH_PREFIX = '@auth/';
export const AUTH_OAUTH_TOKEN_FIRST = `${AUTH_PREFIX}OAUTH_TOKEN_FIRST`;
export const AUTH_OAUTH_TOKEN_SECOND = `${AUTH_PREFIX}OAUTH_TOKEN_SECOND`;
export const AUTH_CHECK = `${AUTH_PREFIX}CHECK`;
export const AUTH_LOGOUT = `${AUTH_PREFIX}LOGOUT`;
export const AUTH_CLEAR_ERRORS = `${AUTH_PREFIX}CLEAR_ERRORS`;
